import { RouterChild } from '@/router';

export default [
  { name: 'admin-organization', path: 'organization', component: () => import('./views/Overview.vue') } as RouterChild
];
